<div class="bg-site-tertiary shadow">
   <header class="container d-flex justify-content-center py-3 pb-2"
           [hidden]="hideHeader">
      <a [routerLink]="['/']">
         <img src="/assets/images/swa-logo_small.png" />
      </a>

      <!--<div class="text-end col-lg-auto mb-lg-0 me-lg-3">
         <button class="btn btn-site-secondary fw-bold text-nowrap ms-2 ps-4 pe-4" (click)="signIn()">SIGN IN</button>
      </div>-->

   </header>
</div>
